import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  
  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay to avoid showing immediately on page load
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const acceptAll = () => {
    localStorage.setItem("cookie-consent", JSON.stringify({
      essential: true,
      analytics: true,
      accepted_at: new Date().toISOString()
    }));
    setShowBanner(false);
  };
  
  const acceptEssential = () => {
    localStorage.setItem("cookie-consent", JSON.stringify({
      essential: true,
      analytics: false,
      accepted_at: new Date().toISOString()
    }));
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card border-t border-border shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1 pr-4">
          <p className="text-sm text-foreground mb-1">
            <strong>We value your privacy</strong>
          </p>
          <p className="text-xs text-muted-foreground">
            We use cookies to enhance your experience, maintain your session, and analyze site usage. 
            By clicking "Accept All", you consent to our use of cookies. 
            <Link to="/privacy" className="text-primary hover:underline ml-1">
              Learn more
            </Link>
          </p>
        </div>
        
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button 
            variant="outline" 
            size="sm"
            onClick={acceptEssential}
            className="text-xs border-border hover:bg-muted/50"
          >
            Essential Only
          </Button>
          <Button 
            size="sm"
            onClick={acceptAll}
            className="text-xs bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Accept All
          </Button>
          <button
            onClick={acceptEssential}
            className="p-1 text-muted-foreground hover:text-foreground ml-2"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
